import React from "react";

const VehicleImagePlaceholder = ({ width = "100%", height = 200 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 320 200"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ display: "block", background: "#f3f4f6", borderRadius: "4px" }}
  >
    <rect width="320" height="200" rx="4" fill="#f3f4f6" />
    <g>
      <circle cx="80" cy="140" r="20" fill="#d1d5db" />
      <circle cx="240" cy="140" r="20" fill="#d1d5db" />
      <rect x="60" y="80" width="200" height="60" rx="16" fill="#e5e7eb" />
      <rect x="100" y="60" width="120" height="30" rx="8" fill="#e5e7eb" />
    </g>
    <text
      x="50%"
      y="50%"
      textAnchor="middle"
      fill="#9ca3af"
      fontSize="20"
      fontFamily="Arial, sans-serif"
      dy=".3em"
    >
      No Image
    </text>
  </svg>
);

export default VehicleImagePlaceholder;